<script>
import { store } from "./store.vue";
/**
 * Anzeige der Übersicht aller verfügbaren Selfservices sowie einer Liste der Aufträge, die noch nicht von Pensus abgerufen wurden.
 * @displayName Änderungsaufträge für Selfservices
 */
export default {
  name: "AenderungsauftraegeSelfService",
  components: {},
  data() {
    return {
      store,
      optionFields: {
        FAMSTD: "FAMSTAND",
        PADRTYP: "ADRTYP",
        ANLIEGEN: "WEB_KONT_GRUND",
        GESCHLECHT: "GESCHLECHT",
        BEITRAGSPFLICHTIG: "BEITRAGSPFLICHTIG",
        PENSART: "PENSARTCUST",
        KRANKENKASSE: "KRANKENKASSE",
        PLKZ: "NATIONALITAET",
        GLKZ: "NATIONALITAET",
        KILO: "KILO",
        FGESFORM: "GESFORM",
        STKL: "STKL",
        GRUND: "BTGFREIGRND",
      },
      dateFields: [
        "GEBDAT",
        "EHEDAT",
        "RENTENBEGINN",
        "APGEBDAT",
        "GUELTIGAB",
        "GUELTIGBIS",
        "AUSTRITTSDATUM",
        "BEITRAGBIS",
        "LETZTE_ZAHLUNG",
        "abDatum",
      ],
      checkboxFields: ["GEB_EINZUG", "MAILBENACH"],
      currencyFields: ["BEITRAGAKTUELL", "BEITRAGNEU", "BEITRAG_LAST"],
      hiddenFields: ["APANSPRNR", "uuid", "KINDER"],
    };
  },
  beforeCreate: function () {
    if (typeof store.masterData.data.sService !== "object")
      store.masterData.data.sService = {};
    //this.$servertalk.doLog("Create");
    //this.$servertalk.doLog("Inhalt store:");
    //this.$servertalk.doLog(store);
  },
  methods: {
    formatCurrencyValue(value) {
      if (typeof value === "number") {
        value += "";
      }
      if (value.length == 0) return "-";
      if (typeof value === "string") {
        // Dezimalpunkt durch Komma ersetzen
        value = value.replace(".", ",");
      }
      // Falls der Wert mit einem Komma beginnt, eine "0" voranstellen
      if (value.startsWith(",")) {
        value = "0" + value;
      }
      // Falls Wert kein Komma enthält, Nachkommastellen ergänzen
      if (value.indexOf(",") < 0) {
        value += ",00";
      } else {
        // Prüfen, ob nach dem Komma nur eine Stelle steht
        if (/,\d$/.test(value)) {
          value += "0"; // Eine Null anhängen, wenn nur eine Dezimalstelle vorhanden ist
        }
      }
      // Ggf. Dezimalpunkt ergänzen
      if (value.indexOf(".") < 0 && value.length > 6) {
        let lengthP1 = value.length - 6;
        value = value.substring(0, lengthP1) + "." + value.substring(lengthP1);
      }
      return value + " €";
    },
    getServices(store, masterSS = true) {
      if (typeof store.selfService !== "object") store.selfService = {};
      if (typeof store.masterData.data.sService !== "object" && masterSS)
        store.masterData.data.sService = {};
      if (typeof store.subData.data.sService !== "object" && !masterSS)
        store.subData.data.sService = {};
      let filtered = JSON.stringify(store.selfService); // Objekt kopieren
      filtered = JSON.parse(filtered);
      const keys = Object.keys(filtered);
      keys.forEach((key, index) => {
        let noSS = false;
        if (masterSS) {
          noSS =
            typeof store.masterData.data.sService[key] !== "object" ||
            Object.keys(store.masterData.data.sService[key]).length == 0;
        } else {
          noSS =
            typeof store.subData.data.sService[key] !== "object" ||
            Object.keys(store.subData.data.sService[key]).length == 0;
        }
        if (noSS) {
          delete filtered[key];
        } else {
          filtered[key].isMaster = masterSS;
        }
      });
      return filtered;
    },
    /*hasEntries(arr) {
      if (!arr || typeof arr !== "object" || Object.keys(arr).length == 0)
        return false;
      return true;
    },*/
    removeData(idx, sName, isMain = true) {
      let ds = store.masterData;
      if (!isMain) ds = store.subData;
      let messageCode = this.$servertalk.removeDataSelfService(sName, idx, ds);
      store.message =
        messageCode == 0
          ? { text: "Ihr Änderungsauftrag wurde gelöscht.", status: "ok" }
          : {
              text:
                "Beim Löschen des Änderungsauftrags trat ein Fehler auf (Error-Code " +
                messageCode +
                ").",
              status: "error",
            };
      /**
       * ein Änderungsauftrag wurde gelöscht
       */
      this.$emit("removed");
    },
  },
  emits: ["removed"],
  computed: {},
};
</script>
<template>
  <div
    v-for="(service, serviceIdx) in getServices(store)"
    :key="'offenA_' + serviceIdx"
    class="offene-auftraege offen-master my-8"
  >
    <h2 class="text-lg text-green-500 p-4 bg-green-50 rounded-md mb-2">
      Folgende Aufträge im Bereich
      <span class="font-bold">{{ service.title }}</span>
      wurden beauftragt aber noch nicht von Pensus abgerufen:
    </h2>
    <div
      v-for="(entry, entryIdx) in store.masterData.data.sService[serviceIdx]"
      :key="'offenE_' + entryIdx"
      class="lg:flex gap-8 antrag-single flex-wrap"
    >
      <div
        class="changed"
        v-for="(field, fieldIdx) in store.masterData.data.sService[serviceIdx][
          entryIdx
        ]['changes']"
        :key="'offenF_' + fieldIdx"
      >
        <div
          v-if="typeof this.optionFields[fieldIdx] === 'string'"
          class="option-changed"
        >
          <!-- Option field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          <span class="val">
            {{
              this.$servertalk.getName(
                this.optionFields[fieldIdx],
                field,
                true /* Der Boolean führt zum Lesen von
            KEY_TXTL statt KEY_TXTK */
              )
            }}
          </span>
        </div>
        <div
          v-else-if="checkboxFields.includes(fieldIdx)"
          class="state-changed"
        >
          <!-- Checkbox field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          <span>{{ field == "0" ? "nein" : "ja" }}</span>
        </div>
        <div v-else-if="dateFields.includes(fieldIdx)" class="date-changed">
          <!-- Date field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          <input
            class="val font-normal disabled:bg-transparent"
            type="date"
            :value="field"
            disabled
          />
        </div>
        <div
          v-else-if="currencyFields.includes(fieldIdx)"
          class="value-changed"
        >
          <!-- Currency field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          {{ formatCurrencyValue(field) }}
        </div>
        <div
          v-else-if="
            fieldIdx == 'KINDER' &&
            Object.keys(
              store.masterData.data.sService[serviceIdx][entryIdx]['changes'][
                'KINDER'
              ]
            ).length > 0
          "
          class="children-changed"
        >
          <!-- Kinder field-->
          <div
            v-for="(children, childrenIdx) in store.masterData.data.sService[
              serviceIdx
            ][entryIdx]['changes']['KINDER']"
            :key="'offenC_' + childrenIdx"
          >
            <div class="child flex gap-4">
              <div
                class="empty:hidden"
                v-for="(child, childIdx) in store.masterData.data.sService[
                  serviceIdx
                ][entryIdx]['changes']['KINDER'][childrenIdx]"
                :key="'offen1C_' + childIdx"
              >
                <div v-if="dateFields.includes(childIdx)" class="date-changed">
                  <!-- Date field -->
                  <span class="label">
                    {{
                      typeof store.selfServiceFields[childIdx] == "object"
                        ? store.selfServiceFields[childIdx]["titleShort"]
                        : childIdx
                    }}:
                  </span>
                  <input
                    class="val font-normal disabled:bg-transparent"
                    type="date"
                    :value="child"
                    disabled
                  />
                </div>
                <div
                  v-else-if="
                    childIdx.substring(0, 7) !== 'uploads' &&
                    childIdx !== 'uuid'
                  "
                >
                  <span class="label">
                    {{
                      typeof store.selfServiceFields[childIdx] == "object"
                        ? store.selfServiceFields[childIdx]["titleShort"]
                        : childIdx
                    }}:
                  </span>
                  <span class="val">{{ child }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            fieldIdx.substring(0, 7) !== 'uploads' &&
            !this.hiddenFields.includes(fieldIdx)
          "
          class="field-changed"
        >
          <!-- Normal field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          {{ field }}
        </div>
      </div>
      <div
        v-if="
          typeof store.masterData.data.sService[serviceIdx][entryIdx][
            'DokBetrRent'
          ] == 'object' &&
          store.masterData.data.sService[serviceIdx][entryIdx]['DokBetrRent']
            .length > 0
        "
      >
        <span class="label">Erforderliche Unterlagen:</span>
        <pre>{{
          store.masterData.data.sService[serviceIdx][entryIdx]["DokBetrRent"]
        }}</pre>
      </div>
      <a
        href="#"
        v-if="!store.masterData.isReadOnly"
        class="antrag-link ml-auto"
        @click.prevent="removeData(entryIdx, serviceIdx)"
      >
        Änderungsauftrag löschen
      </a>
    </div>
  </div>

  <!-- leider voll redundant -->

  <div
    v-for="(service, serviceIdx) in getServices(store, false)"
    :key="'offen2A_' + serviceIdx"
    class="offene-auftraege offen-sub my-8"
  >
    <h2 class="text-lg text-green-500 p-4 bg-green-50 rounded-md mb-2">
      Folgende Aufträge im Bereich
      <span class="font-bold">{{ service.title }}</span>
      wurden beauftragt aber noch nicht von Pensus abgerufen:
    </h2>
    <div
      v-for="(entry, entryIdx) in store.subData.data.sService[serviceIdx]"
      :key="'offen2E_' + entryIdx"
      class="lg:flex gap-8 antrag-single flex-wrap"
    >
      <div
        class="changed"
        v-for="(field, fieldIdx) in store.subData.data.sService[serviceIdx][
          entryIdx
        ]['changes']"
        :key="'offen2F_' + fieldIdx"
      >
        <div
          v-if="typeof this.optionFields[fieldIdx] === 'string'"
          class="option-changed"
        >
          <!-- Option field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          <span class="val">
            {{
              this.$servertalk.getName(
                this.optionFields[fieldIdx],
                field,
                true
              ) /* Der Boolean führt zum Lesen von
            KEY_TXTL statt KEY_TXTK */
            }}
          </span>
        </div>
        <div
          v-else-if="checkboxFields.includes(fieldIdx)"
          class="state-changed"
        >
          <!-- Checkbox field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          {{ field == "1" ? "ja" : "nein" }}
        </div>
        <div v-else-if="dateFields.includes(fieldIdx)" class="date-changed">
          <!-- Date field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          <input
            class="val font-normal disabled:bg-transparent"
            type="date"
            :value="field"
            disabled
          />
        </div>
        <div
          v-else-if="currencyFields.includes(fieldIdx)"
          class="value-changed"
        >
          <!-- Currency field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          {{ formatCurrencyValue(field) }}
        </div>
        <div
          v-else-if="
            fieldIdx == 'KINDER' &&
            Object.keys(
              store.subData.data.sService[serviceIdx][entryIdx]['changes'][
                'KINDER'
              ]
            ).length > 0
          "
          class="children-changed"
        >
          <!-- Kinder field-->
          <div
            v-for="(children, childrenIdx) in store.subData.data.sService[
              serviceIdx
            ][entryIdx]['changes']['KINDER']"
            :key="'offen2C_' + childrenIdx"
          >
            <div class="child flex gap-4">
              <div
                class="empty:hidden"
                v-for="(child, childIdx) in store.subData.data.sService[
                  serviceIdx
                ][entryIdx]['changes']['KINDER'][childrenIdx]"
                :key="'offen21C_' + childIdx"
              >
                <div v-if="dateFields.includes(childIdx)" class="date-changed">
                  <!-- Date field -->
                  <span class="label">
                    {{
                      typeof store.selfServiceFields[childIdx] == "object"
                        ? store.selfServiceFields[childIdx]["titleShort"]
                        : childIdx
                    }}:
                  </span>
                  <input
                    class="val font-normal disabled:bg-transparent"
                    type="date"
                    :value="child"
                    disabled
                  />
                </div>
                <div
                  v-else-if="
                    childIdx.substring(0, 7) !== 'uploads' &&
                    childIdx !== 'uuid'
                  "
                >
                  <span class="label">
                    {{
                      typeof store.selfServiceFields[childIdx] == "object"
                        ? store.selfServiceFields[childIdx]["titleShort"]
                        : childIdx
                    }}:
                  </span>
                  <span class="val">{{ child }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            fieldIdx.substring(0, 7) !== 'uploads' &&
            !this.hiddenFields.includes(fieldIdx)
          "
          class="field-changed"
        >
          <!-- Normal field -->
          <span class="label">
            {{
              typeof store.selfServiceFields[fieldIdx] == "object"
                ? store.selfServiceFields[fieldIdx]["titleShort"]
                : fieldIdx
            }}:
          </span>
          {{ field }}
        </div>
      </div>
      <div
        v-if="
          typeof store.subData.data.sService[serviceIdx][entryIdx][
            'DokBetrRent'
          ] == 'object' &&
          store.subData.data.sService[serviceIdx][entryIdx]['DokBetrRent']
            .length > 0
        "
      >
        <span class="label">Erforderliche Unterlagen:</span>
        <pre>{{
          store.subData.data.sService[serviceIdx][entryIdx]["DokBetrRent"]
        }}</pre>
      </div>
      <a
        href="#"
        v-if="
          !(store.subData.isReadOnly || store.selectedFirma?.VERMITTLER == 1)
        "
        class="antrag-link ml-auto"
        @click.prevent="removeData(entryIdx, serviceIdx, false)"
      >
        Änderungsauftrag löschen
      </a>
    </div>
  </div>
</template>
<style scoped>
.antrag-single {
  @apply even:bg-gray-50 lg:py-2 px-4 py-8 even:border-b border-gray-200 last:border-0 lg:flex text-sm lg:text-xs gap-y-4 gap-x-8 items-stretch;
}

.antrag-link {
  @apply text-primary inline-flex lg:flex items-center relative after:absolute after:transition-all after:duration-500 after:bg-primary after:w-0 hover:after:w-full after:top-full after:h-0.5;
}

.label {
  @apply font-bold block;
}
</style>
